import { createAction } from '@reduxjs/toolkit';

export const storeOrganizationId = createAction<string | null>('session/storeOrganizationId');

export const sessionLogout = createAction('session/logout');
